import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
  site_name: "Aydınlar Sigorta Global",
  tagline: "Güveninizin Global Adresi",
  hero_title: "Geleceğinizi Bugünden Güvence Altına Alın",
  hero_subtitle: "40 yıllık tecrübemiz ile size özel sigorta çözümleri.",
  about_text: "",
  phone: "+90 555 000 00 00",
  whatsapp: "+905550000000",
  email: "info@aydinlarsigortaglobal.com",
  address: "Merkez Mah. Sigorta Cad. No:1 İstanbul",
  working_hours: "Pazartesi - Cumartesi: 09:00 - 19:00",
  bg_color: "#FFFFFF",
  surface_color: "#FAF7F2",
  primary_color: "#D4AF37",
  text_color: "#000000",
  muted_color: "#000000",
  heading_font: "Playfair Display",
  body_font: "Manrope",
  logo_url: "",
  hero_image: "https://images.unsplash.com/photo-1698847626251-efac0f7517cc?q=85",
  slider_images: [],
  insurance_companies: [],
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...FALLBACK, ...data });
    } catch {
      setSettings(FALLBACK);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (!settings) return;
    const root = document.documentElement;
    root.style.setProperty("--asg-bg", settings.bg_color);
    root.style.setProperty("--asg-surface", settings.surface_color);
    root.style.setProperty("--asg-primary", settings.primary_color);
    root.style.setProperty("--asg-text", settings.text_color);
    root.style.setProperty("--asg-muted", settings.muted_color);
    root.style.setProperty("--asg-heading-font", settings.heading_font);
    root.style.setProperty("--asg-body-font", settings.body_font);
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, reload: load, loaded }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
